<template>
    <div class="px-4 py-3 border-b sm:px-6 md:py-3 bg-grey-bg ">
        <div class="progress-steps">
            <component
                :is="step > 1 ? 'router-link' : 'div'"
                :to="step > 1 ? { name: 'applications.welcome.show' } : null"
                :class="{
                    'is-active': step === 1,
                    'is-highlighted': step >= 1
                }"
                class="progress-step is-first"
            >
                <span class="progress-label">Welcome</span>
            </component>
            <span
                :class="{
                    'is-active': step === 2,
                    'is-highlighted': step >= 2
                }"
                class="progress-step"
            >
                <span class="progress-label">Account</span>
            </span>
            <component
                :is="step > 3 ? 'router-link' : 'div'"
                :to="step > 3 ? { name: 'applications.applicants.details.edit' } : null"
                :class="{
                    'is-active': step === 3,
                    'is-highlighted': step >= 3,
                }"
                class="progress-step"
            >
                <span class="progress-label">Details</span>
            </component>
            <component
                :is="step > 4 ? 'router-link' : 'div'"
                :to="step > 4 ? { name: 'applications.applicants.references.edit' } : null"
                :class="{
                    'is-active': step === 4,
                    'is-highlighted': step >= 4
                }"
                class="progress-step"
            >
                <span class="progress-label">Ref<span class="hidden sm:inline">erence</span>s</span>
            </component>
            <div
                :class="{
                    'is-active': step === 5,
                    'is-highlighted': step >= 5,
                }"
                class="progress-step is-last"
            >
                <span class="progress-label">Confirm</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            step () {
                switch (this.$route.name) {
                    case 'applications.welcome.show':
                        return 1
                    case 'applications.users.create':
                    case 'applications.sessions.create':
                    case 'applications.personas.index':
                    case 'applications.tenants.create':
                        return 2
                    case 'applications.applicants.create':
                    case 'applications.applicants.details.edit':
                        return 3
                    case 'applications.applicants.references.edit':
                        return 4
                    case 'applications.applicants.confirm.create':
                        return 5
                    default:
                        return 0
                }
            }
        }
    }
</script>
